import { z } from 'zod';

export const AssetMetricValue = z.object({
    ts: z.coerce.date(),
    value: z.number(),
});

export const AssetMetrics = z.object({
    assetId: z.string(),
    metric: z.string(),
    values: AssetMetricValue.array(),
});
